import moment from 'moment'
import RenderField from '../RenderField'

import useArrayUtils from '../../../../../../hooks/useArrayUtils'

export default function Observations({ observations }) {
    const { isArrayEmpty } = useArrayUtils()

    return (
        <table>
            <thead>
                <tr>
                    <th />
                    <th colSpan={3} style={{ textAlign: 'center'}}>Tobacco</th>
                    <th colSpan={2} style={{ textAlign: 'center'}}>Alcohol</th>
                </tr>
                <tr>
                    <th>Date</th>
                    <th style={{ textAlign: 'center' }}>History of Tobacco</th>
                    <th style={{ textAlign: 'center' }}>Cigs per day</th>
                    <th style={{ textAlign: 'center' }}>Years smoking</th>
                    <th style={{ textAlign: 'center' }}>History of Alcohol</th>
                    <th style={{ textAlign: 'center' }}>Units per week</th>
                </tr>
            </thead>
            <tbody>
                {isArrayEmpty(observations) && (
                    <tr><td colSpan={6}>No information available</td></tr>
                )}
                {observations.map((observation, idx) => (
                    <tr key={idx}>
                        <td><strong>{moment(observation.observationDateTime).format('DD/MM/yyyy')}</strong></td>
                        <RenderField centreAlign>{observation.historyOfTobaccoUse}</RenderField>
                        <RenderField centreAlign>{observation.cigarettesSmokedPerDay}</RenderField>
                        <RenderField centreAlign>{observation.yearsSmoking}</RenderField>
                        <RenderField centreAlign>{observation.historyOfAlcoholUse}</RenderField>
                        <RenderField centreAlign>{observation.unitOfAlcoholPerWeek}</RenderField>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
